import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "./../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import {
    Avatar,
    Button,
    Form,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import { SearchOutlined } from "@ant-design/icons";

const ComplaintsTable = () => {
    const [form] = Form.useForm();

    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
        {
            console.log(record)
            dataIndex === "userId"
                ? record[dataIndex].name
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())},
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    //persian
    const PN = require("persian-number");
    //context
    const { forceUpdate, setForceUpdate } = useContext(context);
    //states
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAnsweresModalOpen, setIsAnsweresModalOpen] = useState(false);
    const [titleComplaint, setTitleComplaint] = useState("");
    const [dataComplaint, setDataComplaint] = useState("");
    const [answerComplaint, setAnswerComplaint] = useState("");
    const [emailComplaint, setEmailComplaint] = useState("");
    const [ComplaintId, setComplaintId] = useState("");
    const [seeAnsweredText, setSeeAnsweredText] = useState("");

    //functions

    const openModal = (record) => {
        setTitleComplaint(record.title);
        setDataComplaint(record.data);
        setComplaintId(record._id);
        setEmailComplaint(record.email);
        setIsModalOpen(true);
    };
    const openAnsweredModal = (record) => {
        setTitleComplaint(record.title);
        setDataComplaint(record.data);
        setComplaintId(record._id);
        setEmailComplaint(record.email);
        setSeeAnsweredText(record.answer.text);
        setIsAnsweresModalOpen(true);
    };

    const handleOk = () => {
        http.post(
            `${config.parkopoloApi}/api/Profile/complaint/${ComplaintId}`,
            {
                title: titleComplaint,
                data: dataComplaint,
                email: emailComplaint,
                text: answerComplaint,
                status: 2,
            }
        )
            .then((res) => {
                setForceUpdate(120);

                toast.success("شکایت با موفقیت پاسخ داده شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                setForceUpdate(12);
            });
        setIsModalOpen(false);
        setForceUpdate(15);
        setAnswerComplaint("");
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setIsAnsweresModalOpen(false);
    };
    //api
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Profile/complaints`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);
    // columns

    const columns = [
        {
            title: "پروفایل کاربر",
            dataIndex: "userId",
            width: "10%",
            render: (_, { userId }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={
                        <img src={`${userId?.coverPic?.address}`} alt="cover" />
                    }
                />
            ),
        },
        {
            title: "نام کاربر",
            dataIndex: "userId",
            ...getColumnSearchProps("userId"),
            width: "10%",
            render: (_, { userId }) => (
                <Typography.Paragraph>{userId?.name}</Typography.Paragraph>
            ),
        },
        {
            title: "عنوان شکایت",
            dataIndex: "title",
            width: "10%",
        },
        {
            title: "ایمیل",
            dataIndex: "email",
            width: "10%",
            render: (_, { email }) => (
                <>
                    <Typography.Paragraph>{email}</Typography.Paragraph>
                </>
            ),
        },
        {
            title: "متن شکایت",
            dataIndex: "data",
            width: "10%",
            render: (_, { data }) => (
                <Tooltip title={data}>
                    <Typography.Paragraph style={{ cursor: "pointer" }}>
                        {data.slice(0, 25)}
                        {data.length > 25 ? "..." : null}
                    </Typography.Paragraph>
                </Tooltip>
            ),
        },
        {
            title: "تاریخ شکایت",
            dataIndex: "createdAt",
            width: "10%",

            render: (_, { createdAt }) => (
                <>
                    <Typography.Paragraph>
                        {PN.convertEnToPe(
                            moment(createdAt.slice(0, 10), "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")
                        )}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "وضعیت شکایت",
            dataIndex: "answer",
            width: "10%",

            render: (_, { answer }) => (
                <>
                    <Typography.Paragraph>
                        {answer.status === 1 ? (
                            <Tag color="red">پاسخ داده نشده</Tag>
                        ) : answer.status === 2 ? (
                            <Tag color="green">پاسخ داده شده</Tag>
                        ) : null}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "5%",
            render: (text, record) => (
                <>
                    {record.answer.status === 1 ? (
                        <Space style={{ width: "100%" }}>
                            <Tooltip title="پاسخ به شکایت">
                                <Button
                                    onClick={() => openModal(record)}
                                    type="primary"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    // disabled={record.answer.status === 2}
                                >
                                    پاسخ
                                </Button>
                            </Tooltip>
                        </Space>
                    ) : record.answer.status === 2 ? (
                        <Space style={{ width: "100%" }}>
                            <Tooltip title="مشاهده پاسخ داده شده">
                                <Button
                                    onClick={() => openAnsweredModal(record)}
                                    type="primary"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    // disabled={record.answer.status === 2}
                                >
                                    مشاهده پاسخ
                                </Button>
                            </Tooltip>
                        </Space>
                    ) : null}
                </>
            ),
        },
    ];
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
            />
            <Modal
                title="ویرایش کامنت"
                open={isModalOpen}
                onCancel={handleCancel}
                okButtonProps={{ hidden: true }}
                cancelButtonProps={{hidden:true}}
            >
                <Form
                    onFinish={handleOk}
                    layout="vertical"
                    form={form}
                    name="control-hooks"
                    style={{
                        direction: "rtl",
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                        // margin: "15px",
                    }}
                >
                    <div style={{ display: "flex" }}>
                        <h3>عنوان شکایت: {titleComplaint}</h3>
                    </div>
                    <div style={{ display: "flex" }}>
                        <h3>متن شکایت: {dataComplaint}</h3>
                    </div>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                        name="پاسخ"
                    >
                        <div>
                            <h3>متن پاسخ :</h3>
                            <Input
                                value={answerComplaint}
                                style={{ margin: "10px", width: "100%" }}
                                placeholder="پاسخ"
                                onChange={(e) => {
                                    setAnswerComplaint(e.target.value);
                                }}
                            />
                        </div>
                    </Form.Item>
                    <Form.Item>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                alignItems: "center",
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                ثبت
                            </Button>
                            <Button
                                type="primary"
                                danger
                                onClick={handleCancel}
                            >
                                لغو
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="مشاهده پاسخ"
                open={isAnsweresModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <div style={{ display: "flex" }}>
                    <h3>عنوان شکایت: {titleComplaint}</h3>
                </div>
                <div style={{ display: "flex" }}>
                    <h3>متن شکایت: {dataComplaint}</h3>
                </div>
                <div style={{ marginTop: "15px" }}>
                    <h3>متن پاسخ :</h3>
                    <h3>{seeAnsweredText}</h3>
                </div>
            </Modal>
        </>
    );
};

export default ComplaintsTable;
